import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../lib/use-locale';
import { Seo } from '../lib/seo';
import { pagePath } from '../config/page-routes';

export function Component() {
  const { t } = useTranslation();
  const locale = useLocale();

  return (
    <>
      <Seo locale={locale} pageId="bonos" />
      <main id="main">
        <section className="coming-soon-section">
          <div className="container coming-soon">
            <h1>{t('bonos.title')}</h1>
            <p className="coming-soon__badge">{t('bonos.comingSoon')}</p>
            <p>{t('bonos.description')}</p>
            <Link to={pagePath('home', locale)} className="button button--primary">
              {t('bonos.backHome')}
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}
